import { Component } from 'react';
import {Switch, Route } from 'react-router-dom';
import React from 'react';
import MessagesOverview from './Overview/';
import ViewMessage from './View';
import setSearchScope from '../../Helpers/setSearchScope';
class Messages extends Component {
    componentDidMount () {
        setSearchScope('messages');
    }
    render() {
        return (
            <Switch>
                <Route
                    exact
                    path='/berichten'
                    render={ (props) =>
                            <MessagesOverview />
                            }/>
                <Route
                    exact
                    path='/berichten/adres/:addressId'
                    render={ (props) =>
                            <MessagesOverview />
                            }/>
                 <Route
                    exact
                    path='/berichten/search/:searchInput'
                    render={ (props) =>
                            <MessagesOverview />
                            }/>
                <Route
                    exact
                    path='/berichten/bekijk/:messageId'
                    render={ (props) =>
                            <ViewMessage />
                            }/>

            </Switch>
        )
    }
}



export default Messages;



// WEBPACK FOOTER //
// ./src/components/Messages/index.js